export default "__VITE_ASSET__Bat3VbeD__"